import { useState } from "react";
import YouTubeEmbed from "../../../../components/elements/YouTubeEmbed";
import ModalNew from "../../../../components/Modal/ModalNew";

export default function Hero() {
  // States
  const [open, setOpen] = useState(false);
  const handleModalClose = () => setOpen(false);

  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-white via-white to-white pt-3 pb-4">
      {/* <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(0,71,255,0.1),transparent_50%)]" /> */}
      {/* <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_60%,rgba(0,174,239,0.08),transparent_50%)]" /> */}

      <div className="relative max-w-[800px] mx-auto px-4 lg:px-8">
        <div className="text-center max-w-4xl mx-auto">
          {/* <h1 className="text-[22px] md:text-[50px] lg:text-[50px] font-bold text-gray-900 mb-3 leading-tight">
            Choose the Perfect AI Recruiter Plan for Your Business
          </h1> */}
          <h1 className="text-lg md:text-[30px] text-primary mb-1 leading-relaxed">
            AI Recruiter
          </h1>
          <p className="text-sm md:text-[20px] text-gray-600 mb-1 leading-relaxed">
            Empower your hiring process with AI-powered interviews, analytics
            and automation.
          </p>
          {/* <a href="#pricing">
            <button className="mx-auto border border-[#0B60D6] bg-gradient-to-r from-[#1976D2]/0 to-[#0B60D6]/0 text-[#0B60D6] hover:shadow-lg transform hover:scale-105 py-2 px-5 rounded-lg transition-all flex items-center justify-center mb-4">
              View Pricing
            </button>
          </a> */}
        </div>
      </div>
      <div className="pt-3 max-w-[450px] mx-auto rounded-full px-3">
        <div
          onClick={() => setOpen(true)}
          className="h-[50px] w-[150px] bg-primary mx-auto cursor-pointer flex justify-center items-center rounded-full border-2 border-primary"
        >
          <div className="border-2 border-white rounded-full h-full w-full flex justify-center items-center">
            <p className="text-white text-[16px] font-medium">Watch Demo</p>
          </div>
          {/* bg-[url(/public/images/bg/demo.jpg)] bg-cover bg-center bg-no-repeat */}
        </div>
        <div className="mx-auto flex justify-center pt-4">
          <div className="text-center">
            <p className="text-sm md:text-[16px] text-gray-600 mb-3">
              Discussion on the AI Recruiter, Cost Implications and Benefits
            </p>
            <audio controls className="mx-auto">
              <source
                src="/audio/The_Million_Naira_Secret_to_AI_Recruitment__Unpacking_the_Hidde.ogg"
                type="audio/ogg"
              />
              <source
                src="/audio/The_Million_Naira_Secret_to_AI_Recruitment__Unpacking_the_Hidde.mp3"
                type="audio/mpeg"
              />
              Your browser does not support the audio element.
            </audio>
          </div>
        </div>
      </div>
      <ModalNew
        isOpen={open}
        onClose={handleModalClose}
        title=""
        className="px-0 md:px-0 py-0 md:py-0 max-w-[895px]"
      >
        <YouTubeEmbed
          videoId="j4aqYvtzOz0"
          mobileHeight={350}
          desktopHeight={505}
        />
      </ModalNew>
    </section>
  );
}
